import type { NumberGenerator } from "@shared-kernel/application/ports/number-generator";

export class RealNumberGenerator implements NumberGenerator {
  getRandomNumberBetween(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
